const meterstatus = [
    { "purpose": 'Street Light' },
    { "purpose": 'Head Office' },
    { "purpose": 'Ward Office' },
    { "purpose": 'Hospital' },
    { "purpose": 'Fire office/station' },
    { "purpose": 'Samaj Mandir' },
    { "purpose": 'Cultural Building' },
    { "purpose": 'Theater' },
    { "purpose": 'Night Shelter Center' },
    { "purpose": 'Library' },
    { "purpose": 'Market' },
    { "purpose": 'Lake/Pond' },
    { "purpose": 'Talav'},
    { "purpose": 'Garden' },
    {"purpose":"UDHYAN BILL"},
    { "purpose": 'Udyan'},
    { "purpose": 'Samshanbhumi' },
    { "purpose": 'Dafanbhumi' },
    { "purpose": 'Kabrastan' },
    { "purpose": 'Signal' },
    { "purpose": 'Swimming Pool'},
    { "purpose": 'Lift'},
    { "purpose": 'Gym'},
    { "purpose": 'Commissioner Sir House'},
    { "purpose": 'Offices' },
    { "purpose": 'Fire Station' },
    { "purpose": 'Other'},
    {"purpose":"Samaj Mandir / Cultural Building / Theter"},
    {"purpose":"Karyalay / Office"},
    {"purpose":"KARYALAY / EMARAT [ O.M]"},
    {"purpose":"Vachnalay"},
    {"purpose":"Toilet"},
    {"purpose":" Ground"},
    {"purpose":"Anganwadi"}
    ];
export default meterstatus;
